import { Cols } from "../../shared/Consts";
import usePortfolio from "../../hooks/PortfolioProvider";
import { usePath } from "../../libs/path/PathProvider";
import PortUtils from "../../portlibs/PortUtils";
import SummaryAsset from "./SummaryAsset";
import HistoryTitle from "./HistoryTitle";
import _ from "lodash";
import HistoryFilter, { useHistoryFilter } from "../../components/HistoryFilter";
import TransactionTable from "../../components/TransactionTable";
import { IHistoryProps } from "../History";

const COLS = [Cols.date, Cols.accountId, Cols.type, Cols.quantity, Cols.price, Cols.gain, Cols.total, Cols.note]
export default function EquityHistory(props:IHistoryProps){
    const {query} = usePath();
    const {portfolio} = usePortfolio()
    const account = PortUtils.getFilter(query).account
    
    const holding = portfolio.holding(props.ticker)!.filterByAccount(account)
    const historyFilter = useHistoryFilter()

    const {rows} = PortUtils.excludeFilter(holding.transactions.slice(0), historyFilter)
    const table = <TransactionTable classNames={{flex1:true}} tableName="trans" {...props} rows={rows} cols={COLS} infiniteScroll={true} holding={holding}/>
    return <>
        <HistoryTitle holding={holding} transactions={rows} cols={COLS}/>
        <SummaryAsset holding={holding}/>
        <div className="flex gap-8 flex-wrap"><HistoryFilter/></div>
        {table}
    </>
}
